import { action, makeObservable, observable } from 'mobx';

export class LoginManager {
  constructor() {
    makeObservable(this);
  }

  @observable additionalLoginExternalResources = [];

  @action setAdditionalLoginExternalResources = (resources) => {
    this.additionalLoginExternalResources = Array.isArray(resources) ? resources : [];
  }
}

export default new LoginManager();
